// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---c9CDV","changedRecordsList":"changedRecordsList---WSrEZ","changedRecord":"changedRecord---zeWS6"};